const note = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20%202a2%202%200%200%201%202%202v13.414L17.414%2022H4a2%202%200%200%201-2-2V4a2%202%200%200%201%202-2h16zm0%202H4v16l11-.001V17a2%202%200%200%201%202-2h3V4zm-.415%2013H17v2.584L19.585%2017zM13%2015v2H7v-2h6zm4-4v2H7v-2h10zm0-4v2H7V7h10z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  note as default
};
//# sourceMappingURL=note.svg.es.js.map
